module.exports = __webpack_public_path__ + "static/media/logout.aa23f251.png";